import { Link } from 'react-router-dom';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: 'ri-award-line',
      title: 'Más de 15 años de experiencia',
      description: 'Profesionales especializados en vaciado y limpieza extrema con más de 850 proyectos completados',
    },
    {
      icon: 'ri-time-line',
      title: 'Disponibilidad 24/7',
      description: 'Servicio de urgencia disponible cualquier día del año, incluidos festivos y fines de semana',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Servicio discreto y profesional',
      description: 'Máxima confidencialidad garantizada en todos nuestros servicios, especialmente en casos delicados',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Presupuesto sin compromiso',
      description: 'Visita gratuita y presupuesto detallado sin ningún tipo de compromiso por tu parte',
    },
    {
      icon: 'ri-recycle-line',
      title: 'Gestión legal de residuos',
      description: 'Nos encargamos de toda la gestión, transporte y reciclaje de residuos según normativa vigente',
    },
    {
      icon: 'ri-team-line',
      title: 'Equipo profesional',
      description: 'Personal cualificado, uniformado y con todas las medidas de seguridad e higiene',
    },
  ];

  return (
    <section className="py-24 bg-silver-light/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-graphite mb-4">
            ¿Por qué elegir <span className="text-primary">JUSTCLEAN?</span>
          </h2>
          <p className="text-lg text-gray-medium max-w-2xl mx-auto">
            Somos la empresa de referencia en Castelldefels para servicios de vaciado y limpieza extrema. <Link to="/empresa" className="text-primary hover:underline font-semibold">Conoce más sobre nosotros</Link>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-card hover:shadow-card-hover hover:-translate-y-2 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-primary rounded-xl flex items-center justify-center mb-5">
                <i className={`${reason.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-graphite mb-3">{reason.title}</h3>
              <p className="text-gray-dark leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-primary rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            ¿Necesitas un servicio de vaciado o limpieza?
          </h3>
          <p className="text-xl mb-8 text-white/90 max-w-2xl mx-auto">
            Contacta con nosotros ahora y recibe tu presupuesto gratuito en menos de 24 horas. <Link to="/faq" className="underline hover:no-underline">Consulta nuestras preguntas frecuentes</Link>
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+34602365996"
              className="px-8 py-4 bg-white text-primary rounded-lg font-semibold text-lg hover:bg-silver-light transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              602 36 59 96
            </a>
            <a
              href="https://wa.me/34602365996"
              className="px-8 py-4 border-2 border-white text-white rounded-lg font-semibold text-lg hover:bg-white hover:text-primary transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
            <Link
              to="/contacto"
              className="px-8 py-4 border-2 border-white text-white rounded-lg font-semibold text-lg hover:bg-white hover:text-primary transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              Formulario
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
